import React from "react";
import CloseIcon from "../../../Assets/Icons/CloseIcon.svg";
import "./styles.css";

const FlyerMessage = ({ message, onClose, styles }) => {
  return (
    <div className="flyer-frame" style={styles}>
      <p className="flyer-text">{message}</p>
      <img
        className="flyer-close-icon"
        alt="Close Icon"
        src={CloseIcon}
        onClick={onClose}
      />
    </div>
  );
};

export default FlyerMessage;
